import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface EntityTypeMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allEntityTypeMaster: [] | null | any;
}
const initialState: EntityTypeMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allEntityTypeMaster: null,
};
export const entityTypeMasterSlice = createSlice({
  name: 'EntityTypeMaster',
  initialState,
  reducers: {
    setAllEntityTypeMaster: (state, action) => {
      state.allEntityTypeMaster = action.payload.data;
    },
    setEntityTypeMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllEntityTypeMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllEntityTypeMaster, setEntityTypeMaster, setAllEntityTypeMasterBySearch,reset } = entityTypeMasterSlice.actions;
export const allEntityTypeMasterDetails = (state: RootState) => state.entityTypeMaster.allEntityTypeMaster;
export const getAllEntityTypeMasterDetails = (state: RootState) => state.entityTypeMaster.data;
export const getEntityTypeMasterTotalRecords=(state:RootState)=>state.entityTypeMaster.totalRecords;
export const getAllEntityTypeMasterBySearch = (state: RootState) => state.entityTypeMaster.data;
export default entityTypeMasterSlice.reducer;